<template>
  <div class="p-introduce">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>关于我们</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box intro-con" v-if="true">
      <div class="box">
        <div class="left_content">
          <p class="left_title">企业简介</p>
          <div class="line"></div>
          <div class="left_text">{{ companyInfo.subtitle }}</div>
        </div>
        <img class="right_img" :src="companyInfo.image" />
      </div>
      <div class="thr-box">
        <div class="con-box">
          <img class="icon" src="../../assets/img/about/cultural/icon.png" />
          <img class="icon0" src="../../assets/img/about/cultural/icon0.png" />
          <p class="text">使命</p>
          <p class="text1">赋能细分领域人才培养</p>
          <p class="text1">赋能区域产业经济发展</p>
        </div>
        <div class="con-box">
          <img class="icon1" src="../../assets/img/about/cultural/icon1.png" />
          <img class="icon2" src="../../assets/img/about/cultural/icon2.png" />
          <p class="text">愿景</p>
          <p class="text1">打造继续教育终身学习平台</p>
        </div>
        <div class="con-box">
          <img class="icon1" src="../../assets/img/about/cultural/icon3.png" />
          <img class="icon2" src="../../assets/img/about/cultural/icon4.png" />
          <p class="text">核心价值观</p>
          <p class="text1">热爱学习，善于分享</p>
          <p class="text1">懂得感恩，乐于付出</p>
          <p class="text1">坚守原则，勇于担当</p>
          <p class="text1">拥抱变化，赋能成长</p>
        </div>
      </div>
      <div>
        <div class="develop-tit">发展历程</div>
        <div class="time">
          <div class="swiper-container" id="swiper1">
            <div class="num swiper-wrapper">
              <div
                class="num_years swiper-slide"
                v-for="(item, index) of introList"
                :key="index"
              >
                <div class="num_year">
                  {{ item.title.slice(0, 4) }}
                </div>
                <div class="dian"></div>
              </div>
            </div>
          </div>

          <div class="time_lines">
            <div class="left_icon swiper-button-prev">
              <img src="../../assets/img/iconrightb.png" />
            </div>
            <div class="time_line"></div>
            <div class="right_icon swiper-button-next">
              <img src="../../assets/img/iconrightb.png" />
            </div>
          </div>
        </div>
        <div class="nav swiper-container" id="swiper2">
          <div class="swiper-wrapper">
            <div
              class="box-content swiper-slide"
              v-for="(item, index) of introList"
              :key="index"
            >
              <div class="year">
                <div class="year-in">
                  <div class="text">{{ item.title }}</div>
                  <div class="eng">year</div>
                </div>
              </div>
              <div class="main">
                <div
                  class="item"
                  v-for="(el, i) in content ? JSON.parse(content) : []"
                  :key="i"
                >
                  <div class="item-left">
                    <div class="dot"></div>
                    <div class="month">{{ el.month }}</div>
                  </div>
                  <div class="item-right">
                    <div
                      class="right-con"
                      v-for="(element, i) in el.content"
                      :key="i"
                    >
                      <div class="dot"></div>
                      <div class="text">
                        {{ element.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 社会责任 -->
    <div class="social">
      <div class="g-box">
        <div class="tit">社会责任</div>
        <div class="swiper-container socail-slide" id="swiper3">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in socialList" :key="item.id">
              <div class="social-con">
                <div class="tt">{{ item.title }}</div>
                <div class="line"></div>
                <div class="con">
                  {{ item.subtitle }}
                </div>
                <div class="ri">
                  <img class="img" :src="item.image" alt="" />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="btn-le swiper-button-prev"></div>
          <div class="btn-ri swiper-button-next"></div> -->
        </div>
      </div>
    </div>
    <!-- 办公环境 -->
    <div class="envir">
      <div class="g-box">
        <div class="envir-tit">办公环境</div>
        <div class="envir-con" v-if="true">
          <div class="envir-le">
            <img class="img" :src="envirList[0] && envirList[0].image" alt="" />
          </div>
          <div class="envir-ri">
            <div class="item" v-for="item in envirArr" :key="item.id">
              <img class="img" :src="item && item.image" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="concat">
      <div class="g-box">
        <div class="concat-con">
          <div class="le">
            <div class="tit">联系我们</div>
            <div class="sub-tit">
              {{ concatInfo.subtitle }}
            </div>
            <div class="phone">{{ concatInfo.title }}</div>
          </div>
          <div class="ri">
            <div class="tit">你也可以留下联系方式</div>
            <div class="sub">专业顾问致电您的电话</div>
            <div class="item">
              <input
                v-model="form.name"
                placeholder="请输入姓名"
                class="ipt"
                type="text"
              />
            </div>
            <div class="item">
              <input
                v-model="form.phone"
                placeholder="请输入电话"
                class="ipt"
                type="text"
              />
            </div>
            <div class="btn" @click="submit">提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import page_mx from "@/mixin/page_mx";
import pageMain_mx from "../../mixins/pageMain_mx";

// import Swiper from "swiper/swiper-bundle";
import Swiper from "swiper";

import { Message } from "element-ui";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      companyInfo: {},
      businessList: [],
      socialList: [],
      content: "",
      envirList: [],
      envirArr: [],
      introList: [],
      concatInfo: {},
      form: {}
    };
  },
  methods: {
    async init() {
      const data = await this.getMenuConfig("企业简介", "");
      this.companyInfo = data;
      const menuId3 = this.getMenuId("我们的历程");
      if (menuId3) {
        const data1 = await this.getMenuList({
          pageNum: 1,
          pageSize: 1000,
          menuId: menuId3
        });
        this.introList = data1;
        await this.getDetail(data1[0].id);
        this.$nextTick(() => {
          this.UserSwiper();
        });
      }
      const menuId4 = this.getMenuId("办公环境");
      if (menuId4) {
        const data2 = await this.getMenuList({
          pageNum: 1,
          pageSize: 1000,
          menuId: menuId4
        });
        this.envirList = data2;
        this.envirArr = data2.slice(1, 5);
        console.log(data2, "data");
      }
      const concatInfo = await this.getMenuConfig("联系我们", "");
      this.concatInfo = concatInfo;
      const menuId5 = await this.getMenuId("社会责任");
      if (menuId5) {
        const data = await this.getMenuList({
          pageNum: 1,
          pageSize: 1000,
          menuId: menuId5
        });
        console.log(data, "data");

        this.socialList = data;
        this.$nextTick(() => {
          this.UserSwiper2();
        });
      }
    },
    async getDetail(id) {
      const res = await this.getAjaxInfo(id);
      this.content = res.content;
    },
    UserSwiper2() {
      // var thumbsSwiper = new Swiper("#swiper4", {
      //   loop: false,
      //   slidesPerView: 4,
      //   spaceBetween: 20,
      //   watchSlidesVisibility: true, //防止不可点击
      // });
      new Swiper("#swiper3", {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // thumbs: {
        //   swiper: thumbsSwiper,
        //   slideThumbActiveClass: "my-slide-thumb-active",
        // },
      });
    },
    getId(i) {
      return this.introList[i].id;
    },
    UserSwiper() {
      var thumbsSwiper = new Swiper("#swiper1", {
        loop: false,
        slidesPerView: 7,
        observer: true,
        observerParents: true,
        watchSlidesVisibility: true //防止不可点击
      });
      new Swiper("#swiper2", {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        disabledClass: "my-button-disabled",
        observer: true,
        observerParents: true,
        thumbs: {
          swiper: thumbsSwiper,
          slideThumbActiveClass: "my-slide-thumb-active"
        },
        on: {
          slideChange: swiper => {
            this.getDetail(this.getId(swiper.realIndex));
          }
        }
      });
    },
    submit() {
      if (!this.form.name) return Message("请先输入姓名");
      if (!this.form.phone) return Message("请先输入手机号");
      this.$api.ums.promote.backgroundMessage_messageForClient
        .post(this.form)
        .then(() => {
          Message.success("提交成功，请耐心等待老师与您联系");
          this.form = {};
        });
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background: url("../../assets/img/about/title.png") no-repeat center;
  background-size: cover;
}
.title_text {
  position: absolute;
  top: 98px;
  left: 50%;
  margin-left: -118px;
  width: 336px;
  font-size: 60px;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
}
.intro-con {
  transform: translateY(-120px);
}
.box {
  width: 1100px;
  height: 260px;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(0, 32, 114, 0.1);
  display: flex;
  justify-content: space-between;
  .left_content {
    position: relative;
  }
  .right_img {
    width: 380px;
    height: 260px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .left_title {
    position: absolute;
    top: 40px;
    left: 59px;
    width: 112px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    z-index: 999;
  }
  .line {
    position: absolute;
    top: 67px;
    left: 59px;
    width: 112px;
    height: 10px;
    background: #ff8012;
    opacity: 0.8;
    z-index: 1;
  }
  .left_text {
    position: absolute;
    top: 120px;
    left: 59px;
    width: 580px;
    height: 84px;
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
  }
}

.thr-box {
  margin-top: 80px;
  margin-bottom: 80px;

  display: flex;
  justify-content: space-between;
  .con-box {
    position: relative;
    width: 354px;
    height: 360px;
    background: #f2f4f9;
    .icon,
    .icon0,
    .icon2,
    .icon1 {
      margin-top: 50px;
      margin-left: 39px;
    }
    .icon3,
    .icon4 {
      position: absolute;
      top: 50px;
      right: 28px;
    }
    .icon0,
    .icon2,
    .icon4 {
      display: none;
    }
    .text {
      height: 45px;
      font-size: 32px;
      font-weight: 400;
      color: #002072;
      line-height: 45px;
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 39px;
    }
    .text1 {
      width: 275px;
      height: 40px;
      font-size: 22px;
      font-weight: 400;
      color: #656878;
      line-height: 24px;
      margin-left: 39px;
    }
  }
  .con-box:hover {
    background: #0030aa;
    .text {
      color: #ffffff;
    }
    .text1 {
      color: #ffffff;
    }
    .icon0,
    .icon2,
    .icon4 {
      display: block;
    }
    .icon,
    .icon1,
    .icon3 {
      display: none;
    }
  }
}
.develop-tit {
  padding-bottom: 80px;
  text-align: center;
  font-size: 36px;
  color: #000;
}
.time {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 100px;
  .num {
    display: flex;
    justify-content: space-between;
    width: 900px;
    .num_years {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      height: 92px;
      cursor: pointer;
      .num_year {
        height: 30px;
        font-size: 22px;
        font-weight: 400;
        color: #656878;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .dian {
        width: 20px;
        height: 20px;
        background: #0030aa;
        border: 6px solid #ffffff;
        border-radius: 20px;
        z-index: 1;
      }
    }
  }
  .time_lines {
    width: 1100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -28px;
    margin-bottom: -30px;
    .time_line {
      width: 1000px;
      height: 6px;
      background-color: #0030aa;
    }
    .left_icon,
    .right_icon {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .left_icon {
      transform: rotate(180deg);
    }
  }
}
.nav {
  .box-content {
    margin-bottom: 120px;
    .year {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: #f1f1f2;
      &-in {
        text-align: center;
        .text {
          font-size: 30px;
          font-weight: 600;
          color: #000;
        }
        .eng {
          font-size: 16px;
          color: #a8aab8;
        }
      }
    }
    .main {
      margin-left: 50px;
      padding-top: 50px;
      .item {
        display: flex;
        margin-bottom: 50px;
        &-left {
          display: flex;
          width: 120px;
          .dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #ff8012;
          }
          .month {
            margin-left: 20px;
            font-size: 18px;
            font-weight: 600;
            line-height: 1;
          }
        }
        &-right {
          .right-con {
            display: flex;
          }
          .dot {
            width: 8px;
            height: 8px;
            background: #c2c4d1;
            border-radius: 50%;
          }
          .text {
            position: relative;
            top: -5px;
            width: 800px;
            margin-left: 20px;
            font-size: 16px;
            padding-bottom: 20px;
          }
        }
      }
    }
  }
}
.my-slide-thumb-active ::v-deep {
  .num_year {
    height: 50px !important;
    font-size: 36px !important;
    font-weight: 600 !important;
    color: #0030aa !important;
    line-height: 50px !important;
  }
  .dian {
    width: 20px !important;
    height: 20px !important;
    background: #ffffff !important;
    border: 6px solid #0030aa !important;
  }
}

.social {
  height: 710px;
  background: url("../../assets/img/social.png") no-repeat;
  background-size: cover;
  box-sizing: border-box;
  .tit {
    padding-top: 80px;
    font-size: 36px;
    text-align: center;
    color: #fff;
  }
  .socail-slide {
    position: relative;
    .btn-le {
      position: absolute;
      top: 200px;
      left: 10px;
      width: 42px;
      height: 42px;
      background-image: url("../../assets/img/economy-inner.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .btn-ri {
      position: absolute;
      top: 200px;
      right: 10px;
      width: 42px;
      height: 42px;
      background-image: url("../../assets/img/economy-inner.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  &-con {
    position: relative;
    margin-left: 80px;
    width: 820px;
    height: 340px;
    margin-top: 60px;
    padding: 60px;
    box-sizing: border-box;
    background: #fff;
    .tt {
      font-size: 24px;
      font-weight: 600;
      color: #000;
    }
    .line {
      margin-top: 30px;
      width: 40px;
      height: 4px;
      background: #ff8012;
    }
    .con {
      padding-top: 40px;
      width: 440px;
      font-size: 14px;
      color: #656878;
    }
    .ri {
      position: absolute;
      top: 30px;
      right: -120px;
      width: 420px;
      height: 280px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.envir {
  padding: 100px 0;
  &-tit {
    font-size: 36px;
    color: #000;
    text-align: center;
  }
  &-con {
    margin-top: 60px;
    display: flex;
    .envir-le {
      margin-right: 10px;
      width: 520px;
      height: 380px;
      // background-image: url("../../assets/img/business-bg.png");
      // background-repeat: no-repeat;
      // background-size: cover;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .envir-ri {
      display: flex;
      flex-wrap: wrap;
      width: 570px;
      .item {
        margin-right: 10px;
        margin-bottom: 10px;
        width: 280px;
        height: 185px;

        .img {
          width: 100%;
          height: 100%;
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}

.concat {
  padding: 100px 0;
  background: #f2f4f9;
  &-con {
    padding: 60px;
    background: #fff;
    display: flex;
    .le {
      padding-right: 60px;
      width: 480px;
      border-right: 1px solid #a8aab8;
      .tit {
        font-size: 44px;
        font-weight: 500;
        color: #000000;
      }
      .sub-tit {
        padding-top: 20px;
        font-size: 16px;
        color: #656878;
      }
      .phone {
        padding-top: 60px;
        font-size: 56px;
        font-weight: bold;
        color: #ff8012;
      }
    }
    .ri {
      text-align: center;
      width: 480px;
      .tit {
        font-size: 24px;
        font-weight: 600;
        color: #000;
      }
      .sub {
        padding-top: 4px;
        font-size: 16px;
        color: #a8aab8;
      }
      .item {
        margin-top: 30px;
        .ipt {
          padding-left: 20px;
          width: 400px;
          height: 44px;
          background: #f2f4f9;
          border: none;
          box-sizing: border-box;
        }
      }
      .btn {
        margin-top: 50px;
        margin-left: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 400px;
        height: 44px;
        background: #ff8012;
        border-radius: 2px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
.swiper-container {
  margin: 0;
}
</style>
